// ===============================================================
// ✅ Firebase — الإعداد الرسمي لتطبيق LIVORA (نسخة مستقرة نهائية)
// ===============================================================

import { initializeApp } from "firebase/app";
import i18n from "./i18n";

import {
  getAuth,
  GoogleAuthProvider,
  OAuthProvider,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from "firebase/auth";

import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// ⭐⭐⭐ مهم جداً: Functions مع تحديد المنطقة
import { getFunctions, httpsCallable } from "firebase/functions";

// ⭐⭐⭐⭐ NEW: Realtime Database
import { getDatabase } from "firebase/database";

// ===============================================================
// 🔥 إعدادات Firebase
// ===============================================================
const firebaseConfig = {
  apiKey: "AIzaSyCJXYtEbx32ZLjlr7hY_iyP6rI6A7DrDJA",
  authDomain: "livora-3fcae.firebaseapp.com",
  projectId: "livora-3fcae",
  storageBucket: "livora-3fcae.firebasestorage.app",
  messagingSenderId: "362810697929",
  appId: "1:362810697929:web:37dc82c757047a6b340518",

  // ⭐ مهم جداً — أضف هذا السطر
  databaseURL: "https://livora-3fcae-default-rtdb.firebaseio.com",
};

// ===============================================================
// 1) تهيئة التطبيق الأساسي
// ===============================================================
const app = initializeApp(firebaseConfig);

// ===============================================================
// 2) الخدمات الأساسية
// ===============================================================
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app, "gs://livora-3fcae.firebasestorage.app");

// ⭐⭐⭐⭐ NEW — Realtime Database
const rtdb = getDatabase(app);

// ===============================================================
// 3) Functions
// ===============================================================
const functions = getFunctions(app, "us-central1");

// ===============================================================
// 4) مزودي تسجيل الدخول
// ===============================================================
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

const appleProvider = new OAuthProvider("apple.com");
appleProvider.addScope("email");
appleProvider.addScope("name");

// ===============================================================
// 5) فحص الاتصال
// ===============================================================
export const checkConnection = () => {
  if (!navigator.onLine) {
    alert(i18n.t("common.offline_error", { defaultValue: "No internet connection." }));
    throw new Error("Offline");
  }
};

// ===============================================================
// ⭐⭐ التصدير النهائي
// ===============================================================
export {
  auth,
  db,
  storage,
  functions,
  rtdb,              // ⭐ NEW
  googleProvider,
  appleProvider,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  httpsCallable,
};
